import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "text-base font-medium text-gray-900" };
const _hoisted_2 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_3 = { class: "mt-4 space-y-4" };
const _hoisted_4 = { class: "h-5 flex items-center" };
const _hoisted_5 = ["id", "name", "value", "disabled", "checked"];
const _hoisted_6 = { class: "ml-3 text-sm" };
const _hoisted_7 = {
    for: "shiftPattern",
    class: "font-medium text-gray-700"
};
import { toRef } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CheckList',
    props: {
        options: {},
        label: {},
        error: {},
        disabled: { type: Boolean },
        modelValue: {},
        name: {}
    },
    emits: ["update:modelValue", "blur"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = toRef(props, 'modelValue');
        const handleClick = (event) => {
            const target = event.target;
            const { name, value } = target;
            if (model.value.includes(value)) {
                const index = model.value.indexOf(value);
                model.value.splice(index, 1);
            }
            else
                model.value.push(value);
            emit('update:modelValue', { name, value: model.value });
        };
        const handleBlur = () => emit('blur');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("fieldset", null, [
                    _createElementVNode("legend", _hoisted_1, _toDisplayString(props.label), 1),
                    _createTextVNode(),
                    (_ctx.error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "\n        * " + _toDisplayString(_ctx.error), 1))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: option,
                                class: "flex items-start"
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("input", {
                                        id: `checklist-option-${option}`,
                                        name: props.name,
                                        value: option,
                                        type: "checkbox",
                                        class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                        disabled: props.disabled,
                                        checked: props.modelValue.includes(option),
                                        onChange: handleClick,
                                        onBlur: handleBlur
                                    }, null, 40, _hoisted_5)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("label", _hoisted_7, _toDisplayString(option), 1)
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
